import { AlertCircle, Check } from 'lucide-react';
import { cn } from '@/lib/utils';

// atom — DWR section complete footer badge. Done / missing variant.
// Pattern .section-complete / .section-complete--missing mockup
// (dev-workspace/mockups/.../project/styles.css righe 1042-1074).
// API minimale (done + hint?) come da decisione C1 del WIP PR 3:
// se done=true → badge "Sezione completata" + Check icon (ink-filled icon).
// se done=false + hint → badge accent border + AlertCircle icon (accent-filled).
// se done=false + no hint → render null (match mockup chrome.jsx SectionComplete).

interface SectionCompleteBadgeProps {
  done: boolean;
  hint?: string | undefined;
  doneLabel?: string;
  className?: string;
}

export function SectionCompleteBadge({
  done,
  hint,
  doneLabel = 'Sezione completata',
  className,
}: SectionCompleteBadgeProps) {
  if (done) {
    return (
      <div
        role="status"
        className={cn(
          'border-ink bg-paper-bright text-ink font-display inline-flex items-center gap-[0.6rem] border-[1.5px] px-[0.95em] py-[0.55em] text-[0.78rem] font-bold tracking-[0.08em] uppercase',
          className,
        )}
      >
        <span
          aria-hidden
          className="bg-ink text-paper-bright grid h-[22px] w-[22px] flex-shrink-0 place-items-center"
        >
          <Check className="h-[14px] w-[14px]" strokeWidth={2.4} />
        </span>
        <span>{doneLabel}</span>
      </div>
    );
  }

  if (hint) {
    return (
      <div
        role="status"
        className={cn(
          'border-accent-dwr bg-paper-bright text-accent-dwr font-display inline-flex items-center gap-[0.6rem] border-[1.5px] px-[0.95em] py-[0.55em] text-[0.78rem] font-bold tracking-[0.08em] uppercase',
          className,
        )}
      >
        <span
          aria-hidden
          className="bg-accent-dwr text-paper-bright grid h-[22px] w-[22px] flex-shrink-0 place-items-center rounded-full"
        >
          <AlertCircle className="h-[14px] w-[14px]" strokeWidth={2.4} />
        </span>
        <span>{hint}</span>
      </div>
    );
  }

  return null;
}
